import clsx from 'clsx';

export default function Button({
    'aria-label': ariaLabel,
    children,
    className,
    'data-testid': dataTestId,
    disabled,
    icon,
    title,
    onClick,
}: ButtonProps) {

    const buttonClasses = clsx('btn', className, icon);

    return <button aria-label={ariaLabel} className={buttonClasses} data-testid={dataTestId} disabled={disabled} title={title} onClick={onClick}>
        {children}
    </button>;

}
